import { Flex, Image, ThemeIcon } from '@mantine/core';
import { IconStars } from '@tabler/icons-react';
import type { CompanyLevelType } from '../../model/companyLevel';
import classes from './CompanyLevelMedalIcon.module.scss';

type CompanyLevelMedalIconProps = {
  muted?: boolean;
  level?: CompanyLevelType;
};

export const CompanyLevelMedalIcon = ({
  muted = false,
  level,
}: CompanyLevelMedalIconProps) => {
  const withLevelGradient = Boolean(level && level !== 'none' && !muted);

  return (
    <Flex pos='relative'>
      {!muted && !withLevelGradient && (
        <Image
          src='/ribbon.svg'
          alt='ribbon'
          w={36}
          h={20}
          pos='absolute'
          top={-12}
          left={2}
        />
      )}
      <ThemeIcon
        className={withLevelGradient ? classes.icon : undefined}
        data-level={withLevelGradient ? level : undefined}
        color={muted ? 'tertiary.0' : 'white'}
        size={40}
        radius={50}
      >
        <IconStars
          size={24}
          color={
            muted
              ? 'var(--mantine-color-tertiary-3)'
              : 'var(--mantine-color-black)'
          }
        />
      </ThemeIcon>
    </Flex>
  );
};
